import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  oakBrookOakBrookLoadingSelector,
  oakBrookFindRequested,
  oakBrookOakBrookLoadedSelector,
  oakBrookDownloadRequested,
  oakBrookFilterSelector,
} from '../../state';
import { LoadingButton } from '../buttons';
import { OakBrookFilters } from './OakBrookFilters';

const ActionContainer = styled.div`
  display: flex;
  width: max-content;
  margin-left: auto;
  justify-content: right;

  > button:first-of-type {
    margin-right: ${props => props.theme.spacing(2)};
  }

  ${props => props.theme.breakpoints.down('md')} {
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }
`;

const ButtonApply = () => {
  const dispatch = useDispatch();
  const handleClickApply = useCallback(() => dispatch(oakBrookFindRequested()), [dispatch]);
  const { t } = useTranslation();
  const loading = useSelector(oakBrookOakBrookLoadingSelector);
  const filters = useSelector(oakBrookFilterSelector);
  const applyDisabled = loading || !filters.country || !filters.month.accept;
  return (
    <LoadingButton
      color="primary"
      variant="contained"
      onClick={handleClickApply}
      loading={loading}
      disabled={applyDisabled}
    >
      {t('navigation.buttons.apply')}
    </LoadingButton>
  );
};

const ButtonDownload = () => {
  const dispatch = useDispatch();
  const handleClickApply = useCallback(() => dispatch(oakBrookDownloadRequested()), [dispatch]);
  const { t } = useTranslation();
  const loaded = useSelector(oakBrookOakBrookLoadedSelector);
  return (
    <Button color="primary" variant="contained" onClick={handleClickApply} disabled={!loaded}>
      {t('navigation.buttons.download')}
    </Button>
  );
};

const OakBrookSearch = () => {
  const loading = useSelector(oakBrookOakBrookLoadingSelector);
  const filters = useSelector(oakBrookFilterSelector);
  const applyDisabled = loading || !filters.country || !filters.month.accept;
  const countryRequiredIncomplete = !loading && !filters.country;
  const monthRequiredIncomplete = !loading && !filters.month.accept;

  const actions = (
    <ActionContainer data-tour="process-actions">
      <ButtonDownload />
      <ButtonApply />
    </ActionContainer>
  );
  return (
    <OakBrookFilters
      actions={actions}
      applyDisabled={applyDisabled}
      countryRequiredIncomplete={countryRequiredIncomplete}
      monthRequiredIncomplete={monthRequiredIncomplete}
    />
  );
};

export default OakBrookSearch;
